"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ember = void 0;

var _utils = require("@sentry/utils");

var _flags = require("./flags");

/** JSDoc */
var Ember = function () {
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function Ember(options) {
    if (options === void 0) {
      options = {};
    }
    /**
     * @inheritDoc
     */


    this.name = Ember.id; // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access

    this._Ember = options.Ember || (0, _utils.getGlobalObject)().Ember;
  }
  /**
   * @inheritDoc
   */


  Ember.prototype.setupOnce = function (_, getCurrentHub) {
    var _this = this;

    if (!this._Ember) {
      _flags.IS_DEBUG_BUILD && _utils.logger.error('EmberIntegration is missing an Ember instance');
      return;
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */


    var oldOnError = this._Ember.onerror;

    this._Ember.onerror = function (error) {
      if (getCurrentHub().getIntegration(Ember)) {
        getCurrentHub().captureException(error, {
          originalException: error
        });
      }

      if (typeof oldOnError === 'function') {
        oldOnError.call(_this._Ember, error);
      } else if (_this._Ember.testing) {
        throw error;
      }
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any


    this._Ember.RSVP.on('error', function (reason) {
      if (getCurrentHub().getIntegration(Ember)) {
        getCurrentHub().withScope(function (scope) {
          if ((0, _utils.isInstanceOf)(reason, Error)) {
            scope.setExtra('context', 'Unhandled Promise error detected');
            getCurrentHub().captureException(reason, {
              originalException: reason
            });
          } else {
            scope.setExtra('reason', reason);
            getCurrentHub().captureMessage('Unhandled Promise error detected');
          }
        });
      }
    });
  };
  /**
   * @inheritDoc
   */


  Ember.id = 'Ember';
  return Ember;
}();

exports.Ember = Ember;